import React, { useEffect, useState } from 'react';
import { Grid, LinearProgress } from "@mui/material";
import DataTable from 'components/DataTable/DataTable';
import { Colors } from "assets/colors";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import RssFeedTwoToneIcon from '@mui/icons-material/RssFeedTwoTone';
import DeviceModal from 'components/DeviceModal/DeviceModal';
import BulkUpload from 'components/BulkUpload/BulkUpload';
import DeleteDeviceModal from 'components/DeviceModal/DeleteDeviceModal';
import { getAllDevices, getDeviceTraceById } from 'apis/device';
import moment from "moment";
import CommonUtil from "../../common/CommonUtil";
import TruckTableHeader from "../../components/TableHeader/TruckTableHeader";

interface DeviceManagerProps {
}

const DeviceManager: React.FC<DeviceManagerProps> = () => {
  const [searchVal, setSearchVal] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [deviceData, setDeviceData] = useState([]);
  const [deviceDataAfterFilter, setDeviceDataAfterFilter] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [deviceToDelete, setDeviceToDelete] = useState(null);
  const [deleteDevice, setDeleteDevice] = useState(false);
  const [editDevice, setEditDevice] = useState(false);
  const [deviceToEdit, setDeviceToEdit] = useState(null);
  const [err, setErr] = useState("");

  const getDeviceList = async () => {
    setIsLoading(true);
    let data = await getAllDevices();
    if (data?.response?.data?.errorMessage) {
      setErr(data.response.data.errorMessage);
      return
    }
    if (data && data.length > 0) {
      data.forEach((object: any) => {
        if ('creationDate' in object && object.creationDate !== null) {
          const date = new Date(object.creationDate);
          object.creationDate = moment(date).local().format('MM/DD/YYYY h:mm:ss A');
        }
        if ('lastUpdateDate' in object && object.lastUpdateDate !== null) {
          const date = new Date(object.lastUpdateDate);
          object.lastUpdateDate = moment.utc(date).local().format('MM/DD/YYYY h:mm:ss A');
        }
        if ('lastReportedHeartbeatTime' in object && object.lastReportedHeartbeatTime !== null) {
          const date = new Date(object.lastReportedHeartbeatTime);
          object.lastReportedHeartbeatTime = moment.utc(date).local().format('MM/DD/YYYY h:mm:ss A');
        }
        if ('lastReportedTipTime' in object && object.lastReportedTipTime !== null) {
          const date = new Date(object.lastReportedTipTime);
          object.lastReportedTipTime = moment.utc(date).local().format('MM/DD/YYYY h:mm:ss A');
        }
      });
      const sortedArray = data.sort((a: any, b: any) => {
        const dateA = new Date(a.lastUpdateDate);
        const dateB = new Date(b.lastUpdateDate);

        if (dateA > dateB) {
          return -1;
        } else if (dateA < dateB) {
          return 1;
        } else {
          return 0;
        }
      });
      setDeviceData(sortedArray);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getDeviceList();
  }, [])

  let tableButtons = [
    {
      label: "Bulk Upload",
      onClickHandler: () => setShowUpload(true),
      buttonStyle: { backgroundColor: Colors.LightBlue, },
      icon: <CloudUploadIcon sx={{ marginRight: ".5rem" }} />
    },
    {
      label: "Add Device",
      onClickHandler: () => setShowModal(true),
      buttonStyle: { backgroundColor: Colors.Red, },
      icon: <RssFeedTwoToneIcon sx={{ marginRight: ".5rem" }} />
    }
  ]

  if(!CommonUtil.isScreenButtonAvailable(CommonUtil.DEVICE_MANAGER,CommonUtil.UPDATE_MODE)){
    tableButtons = [];
  }

  const handleModalAction = async (val: string, data: any) => {
    if(val === "deleteDevice") {
      setDeleteDevice(true);
      setDeviceToDelete(data);
    }
    if(val === "editDevice") {
      setDeviceToEdit(data);
     // setDeviceToHistory(data);
      setShowModal(true);
    }
  };

  const closeDeleteModal = () => {
    setDeleteDevice(false);
    setDeviceToDelete(null);
  }

    // Downloading Only Filtered Data After Search
  const updateFilteredData = (data:[]) => {
    setDeviceDataAfterFilter(data);
  }

  useEffect(() => {
    if(!showModal) {
      setDeviceToEdit(null);
      setDeviceToDelete(null);
    }
  }, [showModal]);

  return (
    <Grid container spacing={2}>
      {isLoading && <LinearProgress />}
      {showModal && <DeviceModal open={showModal} handleClose={setShowModal} getDeviceList={getDeviceList} deviceToEdit={deviceToEdit}/>}
      {showUpload && <BulkUpload open={showUpload} setShowUpload={setShowUpload} handleClose={setShowUpload} fileTypes={[".csv"]} getDeviceList={getDeviceList}/>}
      {deviceToDelete !== null && <DeleteDeviceModal open={deleteDevice} handleClose={closeDeleteModal} device={deviceToDelete} getDevice={getDeviceList}/>}
      <TruckTableHeader actionButtons={tableButtons} searchVal={searchVal} setSearchVal={setSearchVal} data={deviceDataAfterFilter} csvLabel={"devices.csv"} screenName={CommonUtil.DEVICES}/>
      <Grid item xs={12} sx={{ height: "80vh" }}>
        {/* Added Filtered data Download after Search (getFilteredData={updateFilteredData} ) */}
        <DataTable data={deviceData} searchVal={searchVal} openModal={handleModalAction} getFilteredData={updateFilteredData} />
      </Grid>
    </Grid>
  )
}

export default DeviceManager;
